import * as S from './Alignment.styled'
import { useRecoilValue } from 'recoil'
import { alignmentVisibilityAtom } from '@/atoms/_editorAtoms'
import {
  EDITOR_ACTIVE_BORDER_WIDTH,
  EDITOR_INACTIVE_BORDER_WIDTH,
} from '@messenger/consts'

export const VerticalAlignment = ({ left, height, whiteBorder, ...props }) => {
  const alignmentVisibility = useRecoilValue(alignmentVisibilityAtom)
  const isVisible = alignmentVisibility.verticalVisible?.includes(left)
  const isSnapped = alignmentVisibility.verticalSnap === left

  // Adjust guide line position to account for border rendering
  // When width is 0px and border is applied to all sides, the total visual width is 2x the border width
  // (left border + right border). To center the line, shift left by the full border width.
  const borderWidth = isSnapped
    ? EDITOR_ACTIVE_BORDER_WIDTH
    : EDITOR_INACTIVE_BORDER_WIDTH
  const adjustedLeft = left - borderWidth

  return (
    <S.Alignment
      show={isVisible}
      snap={isSnapped}
      position="absolute"
      left={`${adjustedLeft}px`}
      top="0px"
      height={`${whiteBorder ? height - whiteBorder * 2 : height}px`}
      width="0px"
      direction="vertical"
      {...props}
    />
  )
}

export default VerticalAlignment
